import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const routeLabels: Record<string, string> = {
  about: "About",
  contact: "Contact",
  courses: "Courses",
  insights: "Insights",
  news: "News",
  enroll: "Enroll",
  dashboard: "Dashboard",
  "ai-assistant": "AI Assistant",
  login: "Sign In",
  register: "Register",
  "forgot-password": "Forgot Password",
  "confirm-email": "Confirm Email",
  "reset-password": "Reset Password",
  lesson: "Lesson",
  privacy: "Privacy Policy",
  terms: "Terms & Conditions",
  aml: "AML/CTF Policy",
  "enroll-form": "Enroll",
  "learning-experience": "Learning Experience",
  "course-overview": "Course Overview",
  payment: "Payment",
};

const Breadcrumbs = () => {
  const { pathname } = useLocation();
  if (pathname === "/") return null;

  const segments = pathname.split("/").filter(Boolean);

  return (
    <nav className="mx-auto container-page px-4 py-3 sm:px-6" aria-label="Breadcrumb">
      <ol className="flex items-center gap-1.5 overflow-x-auto whitespace-nowrap text-xs text-muted-foreground scrollbar-none">
        <li className="shrink-0">
          <Link to="/" className="hover:text-foreground transition-colors">Home</Link>
        </li>
        {segments.map((seg, i) => {
          const path = "/" + segments.slice(0, i + 1).join("/");
          const isLast = i === segments.length - 1;
          const label = routeLabels[seg] || decodeURIComponent(seg);
          return (
            <li key={path} className="flex shrink-0 items-center gap-1.5">
              <ChevronRight size={12} />
              {isLast ? (
                <span className="text-foreground font-medium">{label}</span>
              ) : (
                <Link to={path} className="hover:text-foreground transition-colors">{label}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
